// import React, { useState, useEffect } from "react";
// import {
//   Typography,
//   Box,
//   Paper,
//   TextField,
//   Button,
//   Grid,
//   CssBaseline,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
// } from "@mui/material";
// import { ThemeProvider, createTheme } from "@mui/material/styles";
// import { CacheProvider } from "@emotion/react";
// import createCache from "@emotion/cache";
// import { useLocation } from "react-router-dom";
// import axios from "axios";
// import Swal from "sweetalert2";

// // RTL theme setup
// const cacheRtl = createCache({ key: "muirtl", prepend: true });
// const theme = createTheme({
//   direction: "rtl",
//   typography: { fontFamily: "Cairo, sans-serif" },
// });

// const initialPermissionState = {
//   employeeName: "",
//   department: "",
//   permissionType: "",
//   permissionReason: "",
//   startTime: "",
//   endTime: "",
// };

// const PermissionRequestForm = ({ isAdmin = false, onSuccess }) => {
//   const [username, setUsername] = useState("");
//   const [employees, setEmployees] = useState([]);
//   const [permissionData, setPermissionData] = useState(initialPermissionState);
//   const [totalPermissionHours, setTotalPermissionHours] = useState(0);
//   const [pendingPermissionHours, setPendingPermissionHours] = useState(0);

//   const location = useLocation();

//   useEffect(() => {
//     const usernameFromLocation = location.state?.username || "";
//     setUsername(usernameFromLocation);

//     if (!isAdmin && usernameFromLocation) {
//       setPermissionData((prev) => ({
//         ...prev,
//         employeeName: usernameFromLocation,
//       }));
//       fetchUserPermissions(usernameFromLocation);
//     }

//     if (isAdmin) fetchEmployees();
//   }, [location, isAdmin]);

//   useEffect(() => {
//     if (username) fetchUserPermissions(username);
//   }, [username]);

//   const fetchEmployees = async () => {
//     try {
//       const res = await axios.get(
//         "https://backenderpforseg.samielmetwali.com/getemployees.php"
//       );
//       setEmployees(res.data.data || []);
//     } catch (err) {
//       console.error("Error fetching employees:", err);
//     }
//   };

//   const fetchUserPermissions = async (targetUsername) => {
//     try {
//       const res = await axios.get(
//         "https://backenderpforseg.samielmetwali.com/getPermissions.php"
//       );
//       const userPermissions = res.data.data.filter(
//         (p) => p.username === targetUsername
//       );

//       let accepted = 0;
//       let pending = 0;

//       userPermissions.forEach((p) => {
//         const start = new Date(`1970-01-01T${p.start_time}Z`);
//         const end = new Date(`1970-01-01T${p.end_time}Z`);
//         const hours = (end - start) / (1000 * 60 * 60);

//         p.is_accepted === 1 ? (accepted += hours) : (pending += hours);
//       });

//       setTotalPermissionHours(accepted);
//       setPendingPermissionHours(pending);
//     } catch (err) {
//       console.error("Error fetching permissions:", err);
//     }
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setPermissionData((prev) => ({ ...prev, [name]: value }));

//     if (name === "employeeName" && isAdmin) {
//       fetchUserPermissions(value);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const { startTime, endTime, employeeName } = permissionData;
//     const start = new Date(`1970-01-01T${startTime}Z`);
//     const end = new Date(`1970-01-01T${endTime}Z`);
//     const hours = (end - start) / (1000 * 60 * 60);

//     if (hours <= 0) {
//       return Swal.fire(
//         "خطأ",
//         "وقت الانتهاء يجب أن يكون بعد وقت البدء",
//         "error"
//       );
//     }

//     try {
//       const res = await axios.get(
//         "https://backenderpforseg.samielmetwali.com/getPermissions.php"
//       );
//       const now = new Date();
//       const currentMonth = now.getMonth();
//       const currentYear = now.getFullYear();

//       const monthlyPermissions = res.data.data.filter((p) => {
//         const date = new Date(p.created_at);
//         return (
//           p.username === employeeName &&
//           p.is_accepted === 1 &&
//           date.getMonth() === currentMonth &&
//           date.getFullYear() === currentYear
//         );
//       });

//       if (monthlyPermissions.length >= 5) {
//         return Swal.fire(
//           "خطأ",
//           "لا يمكن تسجيل أكثر من 5 طلبات في الشهر",
//           "error"
//         );
//       }

//       if (hours > 1) {
//         return Swal.fire(
//           "خطأ",
//           "لا يمكن طلب أكثر من ساعة في الإذن الواحد",
//           "error"
//         );
//       }

//       if (totalPermissionHours + pendingPermissionHours + hours > 5) {
//         return Swal.fire(
//           "خطأ",
//           `لقد طلبت بالفعل ${totalPermissionHours.toFixed(
//             2
//           )} ساعات، وهناك ${pendingPermissionHours.toFixed(
//             2
//           )} ساعات قيد الانتظار. الحد الأقصى هو 5 ساعات.`,
//           "error"
//         );
//       }

//       await axios.post(
//         "https://backenderpforseg.samielmetwali.com/postPermissions.php",
//         {
//           ...permissionData,
//           username: employeeName,
//         }
//       );

//       Swal.fire("تم", "تم إرسال الطلب بنجاح", "success");
//       setPermissionData({
//         ...initialPermissionState,
//         employeeName: isAdmin ? "" : username,
//       });
//       fetchUserPermissions(employeeName);
//       if (onSuccess) {
//         onSuccess();
//       }
//     } catch (err) {
//       Swal.fire("خطأ", "حدث خطأ أثناء الإرسال", "error");
//       console.error(err);
//     }
//   };

//   return (
//     <CacheProvider value={cacheRtl}>
//       <ThemeProvider theme={theme}>
//         <CssBaseline />
//         <Box p={2} dir="rtl">
//           <Typography variant="h5" gutterBottom>
//             إذن تأخير / انصراف
//           </Typography>
//           <Paper sx={{ p: 2 }}>
//             <form onSubmit={handleSubmit}>
//               <Grid container spacing={2}>
//                 <Grid item xs={12}>
//                   {isAdmin && (
//                     <FormControl fullWidth>
//                       <InputLabel id="emp-select">اسم الموظف</InputLabel>
//                       <Select
//                         labelId="emp-select"
//                         name="employeeName"
//                         value={permissionData.employeeName}
//                         onChange={handleChange}
//                       >
//                         {employees.map((emp) => (
//                           <MenuItem key={emp.id} value={emp.username}>
//                             {emp.name}
//                           </MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   )}
//                 </Grid>

//                 {["department", "permissionType", "permissionReason"].map(
//                   (field, index) => (
//                     <Grid key={index} item xs={12}>
//                       <TextField
//                         label={
//                           field === "department"
//                             ? "القسم"
//                             : field === "permissionType"
//                             ? "نوع الإذن"
//                             : "سبب التأخير / الانصراف"
//                         }
//                         name={field}
//                         fullWidth
//                         value={permissionData[field]}
//                         onChange={handleChange}
//                         inputProps={{ style: { textAlign: "right" } }}
//                       />
//                     </Grid>
//                   )
//                 )}

//                 <Grid item xs={6}>
//                   <TextField
//                     label="وقت البدء"
//                     name="startTime"
//                     type="time"
//                     fullWidth
//                     InputLabelProps={{ shrink: true }}
//                     value={permissionData.startTime}
//                     onChange={handleChange}
//                   />
//                 </Grid>
//                 <Grid item xs={6}>
//                   <TextField
//                     label="وقت الانتهاء"
//                     name="endTime"
//                     type="time"
//                     fullWidth
//                     InputLabelProps={{ shrink: true }}
//                     value={permissionData.endTime}
//                     onChange={handleChange}
//                   />
//                 </Grid>

//                 <Grid item xs={12}>
//                   <Button
//                     type="submit"
//                     fullWidth
//                     variant="contained"
//                     color="primary"
//                   >
//                     إرسال
//                   </Button>
//                 </Grid>
//               </Grid>
//             </form>
//           </Paper>
//         </Box>
//       </ThemeProvider>
//     </CacheProvider>
//   );
// };

// export default PermissionRequestForm;

import { useState, useEffect } from "react";
import {
  Typography,
  Box,
  Paper,
  TextField,
  Button,
  Grid,
  CssBaseline,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { useLocation } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";

// RTL theme setup
const cacheRtl = createCache({ key: "muirtl", prepend: true });
const theme = createTheme({
  direction: "rtl",
  typography: { fontFamily: "Cairo, sans-serif" },
});

const initialPermissionState = {
  employeeName: "",
  department: "",
  permissionType: "",
  date: "",
  startTime: "",
  endTime: "",
};

const PermissionRequestForm = ({ isAdmin = false, onSuccess }) => {
  const [username, setUsername] = useState("");
  const [employees, setEmployees] = useState([]);
  const [permissionData, setPermissionData] = useState(initialPermissionState);
  const [totalPermissionHours, setTotalPermissionHours] = useState(0);
  const [pendingPermissionHours, setPendingPermissionHours] = useState(0);

  const location = useLocation();

  // Load user info
  useEffect(() => {
    const usernameFromLocation = location.state?.username || "";
    setUsername(usernameFromLocation);

    if (isAdmin) {
      fetchEmployees();
    } else if (usernameFromLocation) {
      axios
        .get("https://backenderpforseg.samielmetwali.com/getemployees.php")
        .then((res) => {
          const currentUser = res.data.data.find(
            (emp) => emp.username === usernameFromLocation
          );
          if (currentUser) {
            setPermissionData({
              ...initialPermissionState,
              employeeName: usernameFromLocation,
              department: currentUser.department2 || "",
            });
          }
        })
        .catch((err) => console.error("Error loading user:", err));

      fetchUserPermissions(usernameFromLocation);
    }
  }, [location, isAdmin]);

  useEffect(() => {
    if (username) fetchUserPermissions(username);
  }, [username]);

  const fetchEmployees = async () => {
    try {
      const res = await axios.get(
        "https://backenderpforseg.samielmetwali.com/getemployees.php"
      );
      setEmployees(res.data.data || []);
    } catch (err) {
      console.error("Error fetching employees:", err);
    }
  };

  const fetchUserPermissions = async (targetUsername) => {
    try {
      const res = await axios.get(
        "https://backenderpforseg.samielmetwali.com/getPermissions.php"
      );
      const userPermissions = res.data.data.filter(
        (p) => p.username === targetUsername
      );

      let accepted = 0;
      let pending = 0;

      userPermissions.forEach((p) => {
        const start = new Date(`1970-01-01T${p.start_time}Z`);
        const end = new Date(`1970-01-01T${p.end_time}Z`);
        const hours = (end - start) / (1000 * 60 * 60);
        p.is_accepted === 1 ? (accepted += hours) : (pending += hours);
      });

      setTotalPermissionHours(accepted);
      setPendingPermissionHours(pending);
    } catch (err) {
      console.error("Error fetching permissions:", err);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setPermissionData((prev) => {
      const newData = { ...prev, [name]: value };

      // If admin selects employee, auto-fill department
      if (name === "employeeName" && isAdmin) {
        const selectedEmp = employees.find((emp) => emp.username === value);
        if (selectedEmp) {
          newData.department = selectedEmp.department || "";
        }
        fetchUserPermissions(value);
      }

      return newData;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { startTime, endTime, employeeName, department } = permissionData;

    if (!employeeName || !department) {
      return Swal.fire("خطأ", "يجب اختيار الموظف وتحديد القسم", "error");
    }

    const start = new Date(`1970-01-01T${startTime}Z`);
    const end = new Date(`1970-01-01T${endTime}Z`);
    const hours = (end - start) / (1000 * 60 * 60);

    if (hours <= 0) {
      return Swal.fire(
        "خطأ",
        "وقت الانتهاء يجب أن يكون بعد وقت البدء",
        "error"
      );
    }

    try {
      const res = await axios.get(
        "https://backenderpforseg.samielmetwali.com/getPermissions.php"
      );
      const now = new Date();
      const currentMonth = now.getMonth();
      const currentYear = now.getFullYear();

      const monthlyPermissions = res.data.data.filter((p) => {
        const dateObj = new Date(p.created_at);
        return (
          p.username === employeeName &&
          p.is_accepted === 1 &&
          dateObj.getMonth() === currentMonth &&
          dateObj.getFullYear() === currentYear
        );
      });

      if (monthlyPermissions.length >= 5) {
        return Swal.fire(
          "خطأ",
          "لا يمكن تسجيل أكثر من 5 طلبات في الشهر",
          "error"
        );
      }

      if (totalPermissionHours + pendingPermissionHours + hours > 5) {
        return Swal.fire(
          "خطأ",
          `لقد طلبت بالفعل ${totalPermissionHours.toFixed(
            2
          )} ساعات، وهناك ${pendingPermissionHours.toFixed(
            2
          )} ساعات قيد الانتظار. الحد الأقصى هو 5 ساعات.`,
          "error"
        );
      }

      await axios.post(
        "https://backenderpforseg.samielmetwali.com/postPermissions.php",
        {
          ...permissionData,
          username: employeeName,
        }
      );

      Swal.fire("تم", "تم إرسال الطلب بنجاح", "success");
      setPermissionData({
        ...initialPermissionState,
        employeeName: isAdmin ? "" : username,
      });
      fetchUserPermissions(employeeName);
      if (onSuccess) onSuccess();
    } catch (err) {
      Swal.fire("خطأ", "حدث خطأ أثناء الإرسال", "error");
      console.error(err);
    }
  };

  return (
    <CacheProvider value={cacheRtl}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Box p={2} dir="rtl">
          <Typography variant="h5" gutterBottom>
            إذن تأخير / انصراف
          </Typography>
          <Paper sx={{ p: 2 }}>
            <form onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                {isAdmin && (
                  <Grid item xs={12}>
                    <FormControl fullWidth>
                      <InputLabel id="emp-select">اسم الموظف</InputLabel>
                      <Select
                        labelId="emp-select"
                        name="employeeName"
                        value={permissionData.employeeName}
                        onChange={handleChange}
                      >
                        {employees.map((emp) => (
                          <MenuItem key={emp.id} value={emp.username}>
                            {emp.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                )}

                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <InputLabel id="type-label">نوع الإذن</InputLabel>
                    <Select
                      labelId="type-label"
                      name="permissionType"
                      value={permissionData.permissionType}
                      onChange={handleChange}
                    >
                      <MenuItem value="تأخير">تأخير</MenuItem>
                      <MenuItem value="انصراف مبكر">انصراف مبكر</MenuItem>
                      <MenuItem value="خروج مؤقت">خروج مؤقت</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="التاريخ"
                    name="date"
                    type="date"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    value={permissionData.date}
                    onChange={handleChange}
                  />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    label="وقت البدء"
                    name="startTime"
                    type="time"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    value={permissionData.startTime}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    label="وقت الانتهاء"
                    name="endTime"
                    type="time"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    value={permissionData.endTime}
                    onChange={handleChange}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                  >
                    إرسال
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Paper>
        </Box>
      </ThemeProvider>
    </CacheProvider>
  );
};

export default PermissionRequestForm;
